<template>
  <div
    :class="DS_ICON_PICKER_LIST_CLASSES.Empty"
    data-cy="ds-icon-picker-list__empty"
  >
    {{ EMPTY_STATE }}
  </div>
</template>

<script setup lang="ts">
import { DS_ICON_PICKER_LIST_CLASSES } from "@/src/design_system/form_elements/icon_picker/constants/classes";

const EMPTY_STATE = window.I18n.designSystem.iconPicker.emptyState;
</script>
